/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RotateTunneledMcpServerKeyForm,
  RotateTunneledMcpServerKeyForm$Outbound,
  RotateTunneledMcpServerKeyForm$outboundSchema,
} from "../components/rotatetunneledmcpserverkeyform.js";

export type RotateTunneledMcpServerKeySecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RotateTunneledMcpServerKeySecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RotateTunneledMcpServerKeySecurity = {
  option1?: RotateTunneledMcpServerKeySecurityOption1 | undefined;
  option2?: RotateTunneledMcpServerKeySecurityOption2 | undefined;
};

export type RotateTunneledMcpServerKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  rotateTunneledMcpServerKeyForm: RotateTunneledMcpServerKeyForm;
};

/** @internal */
export type RotateTunneledMcpServerKeySecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RotateTunneledMcpServerKeySecurityOption1$outboundSchema:
  z.ZodMiniType<
    RotateTunneledMcpServerKeySecurityOption1$Outbound,
    RotateTunneledMcpServerKeySecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function rotateTunneledMcpServerKeySecurityOption1ToJSON(
  rotateTunneledMcpServerKeySecurityOption1:
    RotateTunneledMcpServerKeySecurityOption1,
): string {
  return JSON.stringify(
    RotateTunneledMcpServerKeySecurityOption1$outboundSchema.parse(
      rotateTunneledMcpServerKeySecurityOption1,
    ),
  );
}

/** @internal */
export type RotateTunneledMcpServerKeySecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RotateTunneledMcpServerKeySecurityOption2$outboundSchema:
  z.ZodMiniType<
    RotateTunneledMcpServerKeySecurityOption2$Outbound,
    RotateTunneledMcpServerKeySecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function rotateTunneledMcpServerKeySecurityOption2ToJSON(
  rotateTunneledMcpServerKeySecurityOption2:
    RotateTunneledMcpServerKeySecurityOption2,
): string {
  return JSON.stringify(
    RotateTunneledMcpServerKeySecurityOption2$outboundSchema.parse(
      rotateTunneledMcpServerKeySecurityOption2,
    ),
  );
}

/** @internal */
export type RotateTunneledMcpServerKeySecurity$Outbound = {
  Option1?: RotateTunneledMcpServerKeySecurityOption1$Outbound | undefined;
  Option2?: RotateTunneledMcpServerKeySecurityOption2$Outbound | undefined;
};

/** @internal */
export const RotateTunneledMcpServerKeySecurity$outboundSchema: z.ZodMiniType<
  RotateTunneledMcpServerKeySecurity$Outbound,
  RotateTunneledMcpServerKeySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RotateTunneledMcpServerKeySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RotateTunneledMcpServerKeySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function rotateTunneledMcpServerKeySecurityToJSON(
  rotateTunneledMcpServerKeySecurity: RotateTunneledMcpServerKeySecurity,
): string {
  return JSON.stringify(
    RotateTunneledMcpServerKeySecurity$outboundSchema.parse(
      rotateTunneledMcpServerKeySecurity,
    ),
  );
}

/** @internal */
export type RotateTunneledMcpServerKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RotateTunneledMcpServerKeyForm: RotateTunneledMcpServerKeyForm$Outbound;
};

/** @internal */
export const RotateTunneledMcpServerKeyRequest$outboundSchema: z.ZodMiniType<
  RotateTunneledMcpServerKeyRequest$Outbound,
  RotateTunneledMcpServerKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    rotateTunneledMcpServerKeyForm:
      RotateTunneledMcpServerKeyForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      rotateTunneledMcpServerKeyForm: "RotateTunneledMcpServerKeyForm",
    });
  }),
);

export function rotateTunneledMcpServerKeyRequestToJSON(
  rotateTunneledMcpServerKeyRequest: RotateTunneledMcpServerKeyRequest,
): string {
  return JSON.stringify(
    RotateTunneledMcpServerKeyRequest$outboundSchema.parse(
      rotateTunneledMcpServerKeyRequest,
    ),
  );
}
